import type { LucideIcon } from 'lucide-react';
import { DetailPanel } from '@/components/common/DetailPanel';
import { Skeleton } from '@/components/ui/skeleton';

interface FeedbackTextPanelProps {
  title: string;
  icon: LucideIcon;
  text: string | null | undefined;
  emptyText: string;
  isLoading: boolean;
}

export function FeedbackTextPanel({
  title,
  icon,
  text,
  emptyText,
  isLoading,
}: FeedbackTextPanelProps) {
  return (
    <DetailPanel title={title} icon={icon}>
      {isLoading ? (
        <div className="flex flex-col gap-2 rounded-xl bg-primary/4 px-4 py-3">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-4/5" />
          <Skeleton className="h-4 w-2/3" />
        </div>
      ) : (
        <blockquote className="rounded-xl bg-primary/4 px-4 py-3 text-base leading-relaxed wrap-break-word whitespace-pre-line">
          {text || <span className="text-sm text-muted-foreground">{emptyText}</span>}
        </blockquote>
      )}
    </DetailPanel>
  );
}
